export default __webpack_public_path__ + "static/media/butterflyMobile.b2ab71d2.png";